import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import VerificationFeature from "./sections/VerificationFeature";
import DueDiligence from "./sections/DueDiligence";
import ProjectHighlights from "./sections/ProjectHighlights";
import TrustSignals from "./sections/TrustSignals";
import PrimaryCallToAction from "./sections/PrimaryCallToAction";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <VerificationFeature />
      <DueDiligence />
      <ProjectHighlights />
      <TrustSignals />
      <PrimaryCallToAction />
      <Footer />
    </div>;
}